<template>
  <div>

      <avue-crud
      :defaults.sync="defaults"
        ref="crud"
        :option="options"
        :data="data"
         v-model="form"
        :simplePage="true"
        @on-load="getList"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @refresh-change="refreshChange"
        @search-reset="searchChange"
        @search-change="searchChange"
      >
        <template slot-scope="{type,size,row,index}" slot="menu">
                  <el-button :type="type" :size="size" v-if="index != 0" icon="el-icon-top" @click="up(index,row)"></el-button>
                  <span v-if="index == 0" style="margin-left:25px"></span>
                  <el-button :type="type" :size="size" v-if="index != data.length - 1" icon="el-icon-bottom" @click="down(index, row)"></el-button>
                  <span v-if="index == data.length - 1" style="margin-right:35px"></span>
                  <el-button :type="type" :size="size" @click="edit(row)">编辑</el-button>
                  <el-button :type="type" :size="size" class="del-btn" @click="rowDel(row)" v-if="data_inputed == 1">删除</el-button>
        </template>
    </avue-crud>
  </div>
</template>

<script>
import {  getModelFieldList,getDataFieldDetail,addModelField,editModelField,exchangeModelFieldSort,deleteField } from '@/page/modelManage/api/model.js';
import {baseUrl} from '@/config';
export default {
  name: "modelField",
  props:['modelId','data_inputed'],
  data() {
    return {
      defaults:{},
      defaultField:{
        list_cell_width: 100,
        show_list: 1,
        remoted: 0
      },
      form:{},
      options: {
        delBtn:false,
        editBtn:false,
        column: [
          {
            label: 'FID',
            prop: 'fid',
            type: 'input',
            rules: [{
                required: true,
                message: "请输入FID",
                trigger: "blur"
              }]
          },
          {
            label: '名称',
            prop: 'name',
            type: 'input',
            rules: [{
                required: true,
                message: "请输入名称",
                trigger: "blur"
              }]
          },
          {
            label: '类型',
            prop: 'type',
            type: 'select',
            dicUrl:`${baseUrl}/adm/meta_model/listByDictCode/META_MODEL_FIELD_TYPE`,
            dataType:'number',
            rules: [{
                required: true,
                message: "请选择类型",
                trigger: "change"
              }]
          },
          {
            label: '存储模式',
            prop: 'storage_mode',
            type: 'switch',
            value:1,
            dicData:[{
              label:'text',
              value:1
            },{
              label:'text/value',
              value:2
            }]

          },
          {
            label: '不能为空',
            prop: 'not_null',
            type: 'switch',
            value:0,
            dicData:[{
              label:'否',
              value:0
            },{
              label:'是',
              value:1
            }]
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea'
          }
        ]
      },
      data: [],
      params: {},

    };
  },

  mounted() {},
  methods: {

    getList() {
      getModelFieldList({s_meta_model_id:this.modelId}).then((res) => {
        if (res.data.success) {
          this.data = res.data.data;
        }
      });
    },
    rowSave(row, done, loading) {
      let saveData = Object.assign(this.defaultField,row);
      saveData.meta_model_id = this.modelId
      addModelField(saveData).then((resp) => {
          if (resp.data.success) {
            this.$message.success("新增成功");
            this.getList();
          }
          done();
        });
    },
    getInfo(row){
      getDataFieldDetail(row.id).then(res=>{
        if(res.data.success){
          this.form = res.data.data
        }
      })
    },
    rowUpdate(row, index, done, loading) {
      let saveData = Object.assign(this.defaultField,row);
      saveData.meta_model_id = this.modelId
      editModelField(saveData).then((resp) => {
          if (resp.data.success) {
            this.$message.success("修改成功");
            this.getList();
          }
          done();
        });
    },
    edit(row){
      this.getInfo(row);
      if(this.data_inputed==0){
        this.defaults.fid.editDisabled=true
        this.defaults.type.editDisabled=true
      }else{
        this.defaults.fid.editDisabled=false
        this.defaults.type.editDisabled=false
      }
      this.$refs.crud.rowEdit(this.form);

    },
    rowDel(row) {
      this.$confirm("是否删除此选中记录?", "提示", { type: "warning" })
        .then(() => {
          deleteField(row.id).then((resp) => {
            if (resp.data.success) {
              this.$message.success("删除成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    searchChange(params, done) {
      if (done) done();
      this.getList();
    },
    refreshChange() {
      this.getList();
    },
    up(index, row) {
      let next = this.data[index - 1]
      exchangeModelFieldSort({
          id1: row.id,
          id2: next.id
        })
        .then(res => {
          if (res.data.success) {
            this.getList()
          }
        })
    },
    down(index, row) {
      let next = this.data[index + 1]
      exchangeModelFieldSort({
          id1: row.id,
          id2: next.id
        })
        .then(res => {
          if (res.data.success) {
            this.getList()
          }
        })
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
